(function () {
  document.documentElement.classList.add('cd-contact-form-js');
  var SECTION_SELECTOR = '[data-cd-contact-form]';
  var HEADER_SELECTOR = '#shopify-section-header-inline, header#shopify-section-header-inline, .shopify-section-header, .t4s-section-header';
  var HEADER_CLASS = 'cd-contact-form-header-is-light';
  var ROOT_CLASS = 'cd-contact-form-header-light';
  var SPLIT_READY = 'cdCfSplitReady';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getHeader() {
    return document.querySelector(HEADER_SELECTOR);
  }

  function splitTextNode(textNode, startIndex) {
    var rawText = textNode.nodeValue || '';
    var index = startIndex || 0;
    var text = rawText.replace(/\s+/g, ' ');

    if (!text.trim()) {
      textNode.parentNode.removeChild(textNode);
      return index;
    }

    if (index === 0) {
      text = text.replace(/^ /, '');
    }

    if (!text.length) {
      textNode.parentNode.removeChild(textNode);
      return index;
    }

    var fragment = document.createDocumentFragment();

    for (var i = 0; i < text.length; i += 1) {
      var char = text.charAt(i);

      if (char === ' ') {
        var space = document.createElement('span');
        space.className = 'cd-cf-space';
        space.innerHTML = '&nbsp;';
        fragment.appendChild(space);
        continue;
      }

      if (/\s/.test(char)) {
        fragment.appendChild(document.createTextNode(char));
        continue;
      }

      var span = document.createElement('span');
      span.className = 'cd-cf-char';
      span.style.setProperty('--cd-cf-char-index', index);
      span.textContent = char;
      fragment.appendChild(span);
      index += 1;
    }

    textNode.parentNode.replaceChild(fragment, textNode);
    return index;
  }

  function splitElement(el) {
    if (!el || el.dataset[SPLIT_READY] === 'true') return;

    var index = 0;

    function walk(node) {
      toArray(node.childNodes).forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE) {
          index = splitTextNode(child, index);
          return;
        }

        if (child.nodeType === Node.ELEMENT_NODE) {
          if (child.classList.contains('cd-cf-char') || child.classList.contains('cd-cf-space')) return;
          walk(child);
        }
      });
    }

    walk(el);
    el.dataset[SPLIT_READY] = 'true';
  }

  function prepareText(section) {
    toArray(section.querySelectorAll('[data-cd-cf-split]')).forEach(splitElement);
  }

  function revealSections() {
    var sections = toArray(document.querySelectorAll(SECTION_SELECTOR));
    if (!sections.length) return;

    sections.forEach(function (section) {
      prepareText(section);
    });

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -12% 0px'
    });

    sections.forEach(function (section) {
      observer.observe(section);

      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        section.classList.add('is-visible');
        observer.unobserve(section);
      }
    });
  }

  function updateFullName(form) {
    if (!form) return;

    var firstName = form.querySelector('[data-cd-cf-first-name]');
    var lastName = form.querySelector('[data-cd-cf-last-name]');
    var fullName = form.querySelector('[data-cd-cf-full-name]');

    if (!fullName) return;

    var value = [firstName && firstName.value, lastName && lastName.value]
      .filter(Boolean)
      .join(' ')
      .trim();

    fullName.value = value;
  }

  var SUBMISSION_STORAGE_KEY = 'cdContactFormSubmissionTarget';

  function readSubmissionTarget() {
    try {
      return JSON.parse(window.sessionStorage.getItem(SUBMISSION_STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeSubmissionTarget(section, form) {
    if (!section || !form) return;

    try {
      window.sessionStorage.setItem(SUBMISSION_STORAGE_KEY, JSON.stringify({
        sectionId: section.id || '',
        formId: form.id || '',
        path: window.location.pathname,
        createdAt: Date.now()
      }));
    } catch (error) {
      // Storage can fail in private browsing. The success/error message scroll
      // below still handles the important post-submit state.
    }
  }

  function clearSubmissionTarget() {
    try {
      window.sessionStorage.removeItem(SUBMISSION_STORAGE_KEY);
    } catch (error) {}
  }

  function getHeaderOffset() {
    var header = getHeader();
    if (!header) return 24;

    var rect = header.getBoundingClientRect();
    var styles = window.getComputedStyle(header);
    var isFixedLike = styles.position === 'fixed' || styles.position === 'sticky';

    if (!isFixedLike && rect.top > 2) return 24;

    return Math.max(24, Math.ceil(rect.height || 0) + 24);
  }

  function scrollToContactTarget(target) {
    if (!target) return;

    var offset = getHeaderOffset();
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'auto'
    });

    if (typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (error) {
        target.focus();
      }
    }
  }

  function restorePostSubmitPosition() {
    var status = document.querySelector(SECTION_SELECTOR + ' [data-cd-cf-status], ' + SECTION_SELECTOR + ' .cd-contact-form__status');
    var hasContactPosted = window.location.search.indexOf('contact_posted=true') > -1;
    var savedTarget = readSubmissionTarget();
    var savedTargetIsFresh = savedTarget && savedTarget.path === window.location.pathname && Date.now() - savedTarget.createdAt < 10 * 60 * 1000;

    if (!status && !hasContactPosted && !savedTargetIsFresh) return;

    if (status && typeof status.focus === 'function') {
      try {
        status.focus({ preventScroll: true });
      } catch (error) {
        // Do not call focus() again without preventScroll; that can move the viewport.
      }
    }

    updateHeaderTheme();
    clearSubmissionTarget();
  }

  function bindForms() {
    toArray(document.querySelectorAll(SECTION_SELECTOR + ' form')).forEach(function (form) {
      if (form.dataset.cdCfBound === 'true') return;
      form.dataset.cdCfBound = 'true';

      form.addEventListener('input', function () {
        updateFullName(form);
      });

      form.addEventListener('submit', function () {
        updateFullName(form);
        writeSubmissionTarget(form.closest(SECTION_SELECTOR), form);
      });

      updateFullName(form);
    });
  }

  function isHeaderOverSection(section, header) {
    if (!section) return false;

    var sectionRect = section.getBoundingClientRect();
    var headerRect = header ? header.getBoundingClientRect() : null;
    var headerBottom = headerRect && headerRect.height ? Math.max(headerRect.bottom, headerRect.height) : 128;
    var headerTop = headerRect ? Math.max(0, headerRect.top) : 0;
    var activationPad = 24;

    return sectionRect.top <= headerBottom + activationPad && sectionRect.bottom >= headerTop + 8;
  }

  function updateHeaderTheme() {
    var sections = toArray(document.querySelectorAll(SECTION_SELECTOR));
    var header = getHeader();
    var active = false;

    sections.forEach(function (section) {
      if (!active && isHeaderOverSection(section, header)) {
        active = true;
      }
    });

    document.documentElement.classList.toggle(ROOT_CLASS, active);
    document.body && document.body.classList.toggle(ROOT_CLASS, active);

    if (header) {
      header.classList.toggle(HEADER_CLASS, active);
      var wrapper = header.querySelector('.cd-hero-header__wrapper, .t4s-header__wrapper, .header-wrapper');
      if (wrapper) wrapper.classList.toggle(HEADER_CLASS, active);
    }
  }

  var ticking = false;
  function requestHeaderUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateHeaderTheme();
      ticking = false;
    });
  }

  function boot() {
    revealSections();
    bindForms();
    updateHeaderTheme();
    requestHeaderUpdate();
    restorePostSubmitPosition();
    window.setTimeout(updateHeaderTheme, 50);
    window.setTimeout(updateHeaderTheme, 250);
    window.setTimeout(updateHeaderTheme, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderUpdate, { passive: true });
  window.addEventListener('pageshow', boot);
  document.addEventListener('cleerdent:ajax-form:updated', function () {
    bindForms();
    updateHeaderTheme();
    requestHeaderUpdate();
  });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
  document.addEventListener('shopify:section:deselect', requestHeaderUpdate);
})();
